import { Banner, BlockStack, Text, InlineStack, Button } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useShop } from '../context/ShopContext';
import { useState, useCallback } from 'react';
import { apiFetch } from '../hooks/useApi';

export default function ReviewPromptBanner() {
  const { t } = useTranslation();
  const { shopInfo, refreshShopInfo } = useShop();
  const [dismissed, setDismissed] = useState(false);

  const handleDismiss = useCallback(async () => {
    setDismissed(true);
    try {
      await apiFetch(`/api/shopify/dismiss-review-prompt`, {
        method: 'POST',
      });
    } catch (err) {
      console.error('Error dismissing review prompt:', err);
    }
  }, []);

  const handleLeaveReview = useCallback(async () => {
    try {
      await apiFetch(`/api/shopify/mark-review-left`, {
        method: 'POST',
      });
    } catch (err) {
      console.error('Error marking review:', err);
    }

    // Open review page
    if (shopInfo?.appStoreReviewUrl) {
      window.open(shopInfo.appStoreReviewUrl, '_blank');
    }

    setDismissed(true);
    refreshShopInfo();
  }, [shopInfo, refreshShopInfo]);

  if (dismissed || !shopInfo?.shouldShowReviewPrompt) {
    return null;
  }

  return (
    <Banner
      title={t('dashboard.reviewPrompt.title')}
      tone="info"
      onDismiss={handleDismiss}
    >
      <BlockStack gap="300">
        <Text as="p">
          {t('dashboard.reviewPrompt.description')}
        </Text>
        <InlineStack gap="200">
          <Button variant="primary" onClick={handleLeaveReview}>
            ⭐ {t('dashboard.reviewPrompt.leaveReview')}
          </Button>
          <Button onClick={handleDismiss}>
            {t('dashboard.reviewPrompt.maybeLater')}
          </Button>
        </InlineStack>
      </BlockStack>
    </Banner>
  );
}
